/**
 * Other News Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initOtherNews() {
        const blocks = document.querySelectorAll('.other-news');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] other-news block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initOtherNews);
    } else {
        initOtherNews();
    }
})();